module.exports = __webpack_public_path__ + "static/ern_opt-fcfbdfe269faa0572e91ecfb44c28383.jpg";